export const AUDIO_RECORDING_MIME_TYPES = [
  "audio/webm;codecs=opus",
  "audio/mp4;codecs=mp4a.40.2",
  "audio/mp4",
  "audio/ogg;codecs=opus",
  "audio/webm",
  "audio/ogg",
];

const APPLE_AUDIO_RECORDING_MIME_TYPES = [
  "audio/mp4;codecs=mp4a.40.2",
  "audio/mp4",
  "audio/aac",
  ...AUDIO_RECORDING_MIME_TYPES,
];

export function usesAppleMediaRecorder(userAgent = globalThis.navigator?.userAgent || "") {
  const value = String(userAgent);
  return /iPhone|iPad|iPod/i.test(value)
    || (/Macintosh/i.test(value) && /AppleWebKit/i.test(value)
      && !/Chrome|Chromium|Edg/i.test(value));
}

export function preferredAudioMimeType(
  MediaRecorderClass = globalThis.MediaRecorder,
  userAgent = globalThis.navigator?.userAgent || "",
) {
  if (!MediaRecorderClass?.isTypeSupported) return "";
  const candidates = usesAppleMediaRecorder(userAgent)
    ? APPLE_AUDIO_RECORDING_MIME_TYPES : AUDIO_RECORDING_MIME_TYPES;
  return candidates.find((type) => MediaRecorderClass.isTypeSupported(type)) || "";
}

export function audioFileExtension(mimeType = "") {
  const baseType = String(mimeType).toLowerCase().split(";", 1)[0].trim();
  if (baseType === "audio/mp4" || baseType === "audio/x-m4a") return "m4a";
  if (baseType === "audio/ogg") return "ogg";
  if (baseType === "audio/wav" || baseType === "audio/x-wav") return "wav";
  if (baseType === "audio/mpeg") return "mp3";
  if (baseType === "audio/aac") return "aac";
  if (baseType === "audio/3gpp") return "3gp";
  return "webm";
}

export function audioFilename(prefix, mimeType) {
  return `${prefix}.${audioFileExtension(mimeType)}`;
}

export function voiceUploadError(error, t, fallback) {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  if (!error?.response) return t("voiceNetworkError");
  if (status === 400 && /empty/i.test(String(detail || ""))) return t("voiceRecordingEmpty");
  if (status === 401) return t("voiceSessionExpired");
  if (status === 415) return t("voiceFormatUnsupported");
  if (status === 413) return t("voiceFileTooLarge");
  return status >= 500 || !fallback ? t("sendFailed") : fallback;
}

export async function recordedAudioIsAudible(blob, AudioContextClass) {
  if (!blob?.size) return false;
  const Context = AudioContextClass || globalThis.AudioContext || globalThis.webkitAudioContext;
  if (!Context || typeof blob.arrayBuffer !== "function") return true;
  const context = new Context();
  try {
    const decoded = await context.decodeAudioData(await blob.arrayBuffer());
    if (!decoded?.duration || !decoded.numberOfChannels) return false;
    for (let channelIndex = 0; channelIndex < decoded.numberOfChannels; channelIndex += 1) {
      const samples = decoded.getChannelData(channelIndex);
      const step = Math.max(1, Math.floor(samples.length / 100000));
      for (let index = 0; index < samples.length; index += step) {
        if (Math.abs(samples[index]) >= 0.0001) return true;
      }
    }
    return false;
  } catch (_error) {
    return false;
  } finally {
    await context.close?.();
  }
}
